import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'common/Modal';
import I18n from 'modules/i18n';
import ButtonWithTooltip from './ButtonWithTooltip';
import Form from './Form';
import Icon from '../../../../ui/Icon';

const CloneButton = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = (event) => {
    event.preventDefault();
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <span>
      <ButtonWithTooltip
        ariaLabel={`${I18n.t('copy')} ${props.title}`}
        className="tw-box-border tw-inline-flex tw-items-center tw-justify-center tw-w-7 tw-h-7"
        tooltipContent={I18n.t('make_a_copy')}
        onClick={openModal}
      >
        <Icon icon="Copy" size={18} />
      </ButtonWithTooltip>
      <Modal
        closeModal={closeModal}
        isOpen={modalIsOpen}
        headerText="Save New Presentation"
      >
        <Form
          button="clone"
          {...props}
        />
      </Modal>
    </span>
  );
};

export default CloneButton;

CloneButton.propTypes = {
  hideTabs: PropTypes.bool,
  id: PropTypes.number.isRequired,
  modalIsOpen: PropTypes.bool,
  slideShowId: PropTypes.number,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  useNewBuilder: PropTypes.bool.isRequired,
};

CloneButton.defaultProps = {
  hideTabs: false,
  modalIsOpen: false,
  slideShowId: null
};
